import template from './activities-review.html'

export let activitiesReview = {
	template    : template,
	controllerAs: 'vm',
	controller  : [ '$state', '$cookies', '$stateParams', '$mdToast', 'GlobalConfig', 'WorkPlanSrv', 'WorkPlanModalSrv', 'ReviewSrv', 'Validations', 'Setters', 'Requests', '$scope', '$rootScope', 'GlobalSrv',
		function activitiesReviewCtrl ($state, $cookies, $stateParams, $mdToast, GlobalConfig, WorkPlanSrv, WorkPlanModalSrv, ReviewSrv, Validations, Setters, Requests, $scope, $rootScope, GlobalSrv) {
			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
			const currentModule = $state.current.module
			const modules = GlobalConfig.modules // Object.keys(GlobalConfig.modules)

			const currentRoleId = JSON.parse($cookies.get('hasRoleId'))
			const validBitacora = (currentRoleId == 18) ? true : false
			const validUser = Validations.validUser(currentRoleId, currentStage)

			$scope.wpId = $stateParams.workplanId
			this.hasDetails = false

			// constants
			angular.extend(this, {
				currentStage : currentStage,
				currentModule: currentModule,
				mainLabel    : $state.current.data.displayName,
				inExecution  : Validations.inExecution(currentStage),
			})

			// variables
			$scope.isLoading = true
			this.imgEmpty = require('../../../assets/images/empty_state_illustration.svg')
			this.teacher = $stateParams.name || $cookies.get('teacherNameSelected')
			const teacherId = $stateParams.teacherId || JSON.parse($cookies.get('currentUser')).teacherId
			const workplanId = $stateParams.workplanId || JSON.parse($cookies.get('currentUser')).workplanId

			const formatActivity = Setters.formatActivity(Setters.setTagName(Validations))
			const getReviewList = Requests.getReviewList(teacherId, workplanId, ReviewSrv, false)

			const setDetailsHeader = Requests.setDetailsHeader(Validations)
			const getActivityDetails = Requests.getActivityDetails(ReviewSrv, setDetailsHeader)

			const formatSubjectActivity = Requests.formatSubjectActivity(Requests.normalizeActivity(Requests.setNullHours))
			const routeDetails = Requests.routeDetails(Validations, Requests.setNullHours, Requests.setStudentAttentionData, formatSubjectActivity)

			let _moduleName = ''

			$rootScope.setHandsProgress = false

			// variables
			angular.extend(this, {
				activities      : [],
				showData        : false,
				viewLoaded      : true,
				filter          : '',
				selectedActivity: null,
				details         : null, // detailed data of selected activity
				isLoadingDetails: false, // circular loading animation for details data
				noData          : false,
				bitacora        : { hide: true, tagName: '' },
				planning        : [], // custom variable for Subject activities
				teaching        : [], // custom variable for Subject activities
				otherActivity   : [], // custom variable for Other Activities (teaching) activities
				teacherId       : teacherId,
				workplanId      : workplanId,
			})

			// methods
			angular.extend(this, {
				loadDetails   : loadDetails,
				updateFilter  : (val) => { this.filter = val },
				thereIsDetails: () => this.details !== null,
			})

			// services

			this.$onInit = () => {
				unauthorize(validUser)
				_moduleName = Object.keys(modules).find(key => modules[key] === currentModule)
				getReviewList(_moduleName).then((data) => {
					this.activities = formatActivity(data, 0) // Setters.sortActivitiesList(formatActivity(data))

					if (this.activities.length > 0) this.loadDetails(this.activities.find(activity => activity !== undefined))

					$scope.isLoading = false
				})
			}

			function unauthorize (authorized) {
				if (!authorized) $state.go('app.unauthorized')
			}

			function getFieldUpdate (stage) {
				switch (stage) {

				case 'review':
					return 'isReviewed'
				case 'approval':
					return 'isApproved'
				case 'evaluation':
					return 'isAccept'
				case 'execution':
					return 'isApproved'
				case 'reviewExecution':
					return 'isExecution'
        
				}
			}

			function calcHours(arr, param) {
				return arr.reduce((accumulator, current) => (accumulator + current[param]), 0)
			}

			function loadDetails (activity, index) {
				activity.userId = JSON.parse($cookies.get('currentUser')).id
				this.details = null
				this.hasDetails = this.thereIsDetails()
				this.noData = Validations.isSubjectType(activity) && activity.isForPlan === 0

				if (!this.noData) {
					$rootScope.setHandsProgress = true
					this.bitacora.hide = validBitacora
					this.bitacora.tagName = activity.tagName
					this.activityTypeId = activity.activityTypeId
					this.workplanTeacherId = activity.workplanTeacherId
					this.isLoadingDetails = true
					this.selectedActivity = activity

					GlobalSrv.subscribe($scope, $rootScope, 'ApproveRepprove', (data) => {
						this.selectedActivity.isApproved = data.status
						this.activities.find(act => {
							return data.activity.workplanTeacherActivityId === act.workplanTeacherActivityId
						})[getFieldUpdate(data.currentStage)] = data.status
					})

					isStageFinish(teacherId).then((stage) => {
						getActivityDetails(_moduleName, activity).then((detailsResponse) => {
							if (detailsResponse === 'error in communication' && !detailsResponse.status) {
								this.noData = true
								this.details = null
								$rootScope.setHandsProgress = false
								this.isLoadingDetails = false

								return
							} 

							const dataActivity = detailsResponse.data || detailsResponse.parent || detailsResponse

							if (index >= 0) {
								if (dataActivity.header && dataActivity.header.length) {
									this.activities[index].workplanTeacherActivityId = dataActivity.header[0].workplanTeacherActivityId
								} else {
									this.activities[index].workplanTeacherActivityId = dataActivity.workplanTeacherActivityId
								}
							} else if (this.activities.length && !index) {
								if (dataActivity.header && dataActivity.header.length) {
									this.activities[0].workplanTeacherActivityId = dataActivity.header[0].workplanTeacherActivityId
								} else {
									this.activities[0].workplanTeacherActivityId = dataActivity.workplanTeacherActivityId
								}
							}

							$cookies.put('executionFinish', stage.executionFinish)
							this.details = routeDetails(_moduleName, activity, detailsResponse)
							this.hasDetails = this.thereIsDetails()
							this.details.data.isItemRequired = 0

							if (Validations.isSubjectType(activity)) {
								this.details.data.isItemRequired = detailsResponse.data.isItemRequired
							}
                
							if (this.details.data) {
								this.details.data.isBlocked = 0
								this.details.data.userId = stage.userId
								this.details.data.executionFinish = stage.executionFinish !== 'error' ? stage.executionFinish : null
								this.details.data.approvedFinish = stage.approvedFinish
								this.details.data.evaluationFinish = stage.evaluationFinished
								this.details.data.reviewedFinish = stage.reviewedFinish
								this.details.data.executionReviewedFinished = stage.executionReviewedFinished
								this.details.data.feedback = stage.isFeedback
								this.details.data.isState = stage.isState
								this.details.data.planningFinish = stage.planningFinish
								this.details.data.stageId = stage.stageId
								this.details.data.totalExecutedHours = this.details.children ? calcHours(this.details.children, 'hoursExecuted') : 0
								this.details.data.totalPlannedHours = this.details.children ? calcHours(this.details.children, 'hoursPlanned') : 0

								if (this.details.data.hoursExecuted === 0) {
									this.details.data.isBlocked = 1
								}
							} else {
								this.noData = true
								this.details = null
							}

							$rootScope.setHandsProgress = false
							this.isLoadingDetails = false
						})
					})
				}
			}

			function isStageFinish (teacherIds) {
				return ReviewSrv.getWorkPlanGeneralDetail.get({ teacherId: teacherId, wp: $scope.wpId }).$promise.then((dataReturn) => {
					if (dataReturn.status) {
						const stage = dataReturn.data.wokplanTeacherStatus[0]

						$cookies.put('workplan-approvedFinish', stage.approvedFinish)
						$cookies.put('workplan-executionFinish', stage.executionFinish)

						return stage
					}

					return null
				})
			}

			GlobalSrv.subscribe($scope, $rootScope, 'isStrategicTracing', (data) => {
				this.selectedActivity.isStrategicTracing = data.isStrategicTracing
				this.activities.find(act => {
					return data.workplanTeacherActivityId === act.workplanTeacherActivityId
				}).isStrategicTracing = data.isStrategicTracing
			})
		},
	],
}




// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review.js